(function () {
    'use strict';

    let module = angular.module('imApp');

    module.component('calculationTextilemodel', {
        templateUrl: 'views/components/views/calculationTextilemodel/calculationTextilemodel.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', '$timeout', 'stateService', 'calculationTextilemodelService', function ($stateParams, $timeout, stateService, calculationTextilemodelService) {
            let vm = this;

            //console.dir($stateParams);
            //console.dir(stateService);

            // #region VARIABLES & DEFINITIONS

            vm.grid = {
                dataTask: {
                    //rememberId: 'w_gridexportarg.stockplace_id',            // Id used to retrieve user configs for the grid
                    rememberId: 'w_calculationtextilemodel',            // Id used to retrieve user configs for the grid
                    loadSetupId: null,                                  // Uses default if null or undefined
                    loadData: {                                         // Method id of the get data procedure
                        method: 2257,
                        parameters: { calculationhead_keyno: $stateParams.calculationhead_keyno, textilemodelcategory7_keyno: $stateParams.textilemodelcategory7_keyno }
                    },
                    addRow: {                                           // NOT IMPLEMENTED
                        method: null,
                        parameters: null
                    },
                    removeRow: {                                        // NOT IMPLEMENTED
                        method: null,
                        parameters: null
                    },
                    saveData: {                                         // NOT IMPLEMENTED
                        method: null,
                        parameters: null,
                        autoSave: true
                    }
                },
                translations: [],                                       // Comma separated list of words to be translated
                config: {                                               // TouchTime parameters configuring the grid
                    //editColumns: ['prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'],
                    toolbar: {                                          // alternative -> toolbar: false,
                        hidden: false,
                        pdfExport: true,
                        excelExport: true,
                        filter: true,
                        columnVisibility: true,
                        headers: true,
                        edit: false,
                        lock: false,
                        add: false,
                        addSimple: false,
                        delete: false,
                        save: false,
                        wrapping: true,
                        layouts: true,
                        refresh: false,
                        read: true,
                        rebind: false,
                        print: false,
                        buttons: [                                      // List of custom buttons
                            //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
                            //{ name: 'customUpdatePrice', text: 'OPPDATER PRIS', func: function () { pricelistUpdate(); }, icon: 'track-changes-enable', cssClass: 'btn btn-primary im-grid-btn-xs-r' }, //fa-money-check-edit-alt
                            //{ name: 'customInvoice', text: 'LAG FAKTURA', func: function () { testItems(); }, icon: 'checkbox-checked', cssClass: 'btn btn-primary im-grid-btn-xs-r' },
                            //{ name: 'customTest', text: 'Dette er en tekst', func: function () { testItems(); }, icon: 'star' }
                            //{ name: 'recalculate', text: 'recalculate', func: function () { recalculate(); }, icon: 'fa-calculator', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true, disabled: function () { return false; } },
                            { name: 'recalculate', text: 'recalculate', func: function () { recalculate(); }, icon: 'calculator', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', translate: true, disabled: function () { return false; } },
                            { name: 'updatePrice', text: 'update_price', func: function () { updatePrice(); }, icon: 'track-changes-enable', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', translate: true, disabled: function () { return hasDirty(); } },
                            { name: 'updateTargetPrice', text: 'update_target_price', func: function () { updateTargetPrice(); }, icon: 'track-changes-enable', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', translate: true, disabled: function () { return hasDirty(); } }
                        ]
                    },
                    fixedHeader: true,                                  // Enables header to stay visible when scrolling
                    keepSortOnAdd: false,                               // Clears sorting when adding a row
                    keepSortOnCheckbox: false,                          // Clears sorting on any clicked checkbox if false
                    keepSortOnIsSelected: false,                        // Clears sorting on only is_selected checkbox if false
                    rowClick: false,                                    // Enables functionality for drilldown on clicked row
                    specialFunc: {                                      // IN DEVELOPMENT
                        newTab: true,                                   // If data has path, adds predefined additional button to functions
                        buttons: [
                            //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } }
                        ]
                    },
                    css: {
                        altColor: true                                  // accepts -> true, false or hexbased color (i.e: '#A1B2C3')
                    }
                },
                kendo: {                                                // Kendo parameters configuring the grid
                    height: '100%',                                       // Sets the height of the grid component
                    //aggregate: [                                      // accepts -> true, false or list of objects (i.e: [{ field: 'amount_invval', aggregate: 'sum' } ])
                    //    { field: 'stock_stockvalue', aggregate: 'sum' }
                    //],
                    pager: false,                                       // NOT IMPLEMENTED
                    //selectable: 'multiple, row',                      // accepts -> true, false, 'row', 'multiple' or 'multiple, row'
                    selectable: false,                                  // accepts -> true, false, 'row', 'multiple' or 'multiple, row'
                    //persistSelection: false,                          // NOT IN USE
                    filterable: false                                   // Adds/Removes filter row, default is set to { mode: "row" }
                },
                optionfunc: function (data) { optionfunc(data.data); }, // Used for referencing functions in the current Component
                gridfunc: null                                          // Used for referencing functions in the Grid Component
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region OPTIONFUNC

            let optionfunc = function (data) {
                //console.log('optionfunc');
                //if (angular.isDefined(data.func) && data.func === 'CellClickHandler') {
                //    console.log('optionfunc - CellClickHandler');
                //    console.dir(data);
                //}

                //if (angular.isDefined(data.func) && data.func === 'OnCellClose') {
                //    console.log('optionfunc - OnCellClose');
                //    console.dir(data);
                //}

                //if (angular.isDefined(data.func) && data.func === 'LookupCellEditor') {
                //    console.log('optionfunc - LookupCellEditor');
                //    console.dir(data);
                //}
            };

            // #endregion OPTIONFUNC

            // #region TOOLBAR BUTTON VALIDATION

            let getIsSelectedItems = function () {
                let dirtyItems = vm.grid.gridfunc?.getDirtyRows() || [];
                let isSelectedItems = [];

                angular.forEach(dirtyItems, function (item) {
                    if (angular.isDefined(item) && item.is_selected === true) isSelectedItems.push(item);
                });

                return isSelectedItems;
            }

            let hasDirty = function () {
                let parmItems = getIsSelectedItems();

                if (parmItems.length > 0) return false;

                return true;
            };

            let disable = function () {
                return true;
                //if (isSaveRunning) return true;
            };

            // #endregion TOOLBAR BUTTON VALIDATION

            // #region TOOLBAR BUTTON FUNCTIONS

            let recalculate = function () {
                console.log('Recalculate');
                //var index = $scope.gridOptions.gridfunc.addRowBefore();
                //calculationTextilemodelService.pricelistUpdate().then()
                calculationTextilemodelService.recalculate({ calculationhead_keyno: $stateParams.calculationhead_keyno }).then(function (data) {
                    //console.log('Done');
                    //console.dir(data);
                    //if (result[0].errorcode === '0') {
                    //    vm.grid.gridfunc.rebind();
                    //}

                    vm.grid.gridfunc?.rebind();
                });
            };

            let updatePrice = function () {
                console.log('Update Price');
                //var index = $scope.gridOptions.gridfunc.addRowBefore();
                //calculationTextilemodelService.pricelistUpdate().then()
                calculationTextilemodelService.updatePrice({ items: getIsSelectedItems() }).then(function (data) {
                    //console.log('Done');
                    //console.dir(data);
                    //if (result[0].errorcode === '0') {
                    //    vm.grid.gridfunc.rebind();
                    //}
                    vm.grid.gridfunc?.rebind();
                });
            };

            let updateTargetPrice = function () {
                console.log('Update Target Price');
                //var index = $scope.gridOptions.gridfunc.addRowBefore();
                //calculationTextilemodelService.pricelistUpdate().then()
                calculationTextilemodelService.updateTargetPrice({ items: getIsSelectedItems() }).then(function (data) {
                    //console.log('Done');
                    //console.dir(data);
                    //if (result[0].errorcode === '0') {
                    //    vm.grid.gridfunc.rebind();
                    //}
                    vm.grid.gridfunc?.rebind();
                });
            };

            // #endregion TOOLBAR BUTTON FUNCTIONS
        }]
    });
})();
